import {Component, NgModule} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-footer',
  template: `
    <footer>
      Copyright © 2012-{{Year}}.
      <br/>
      All trademarks or registered trademarks are property of their respective owners. <br/>
      <a style="cursor: pointer" [href]="'/secured/terms&conditions'" [target]="'_parent'">Terms & Conditions</a>
      | <a style="cursor: pointer" [href]="'/secured/privacy'" target="_parent">Privacy</a>
      | <a style="cursor: pointer" [href]="'https://ocllis.notion.site/ca9d59888edf4f3a8cb154666df6d61f?v=4adb399842494ca8a5bb658ebcf02af5'" target="_blank">Help</a>
    </footer>
  `,
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent {

  get Year() {
    return moment().year();
  }
}

@NgModule({
  declarations: [FooterComponent],
  exports: [FooterComponent]
})
export class FooterModule {
}
